import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  createLocation, 
  updateLocation, 
  deleteLocation, 
  pageLocations, 
  getLocationDetail 
} from '../../api/accompanyShoppingLocation';
import { message } from 'antd';

// 创建陪逛地点
export const createAccompanyShoppingLocation = createAsyncThunk(
  'accompanyShoppingLocation/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await createLocation(data);
      message.success('创建成功');
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '创建失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 更新陪逛地点
export const updateAccompanyShoppingLocation = createAsyncThunk(
  'accompanyShoppingLocation/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateLocation(id, data);
      message.success('更新成功');
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '更新失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 删除陪逛地点
export const deleteAccompanyShoppingLocation = createAsyncThunk(
  'accompanyShoppingLocation/delete',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await deleteLocation(id);
      message.success('删除成功');
      // 删除成功后重新获取列表
      dispatch(fetchAccompanyShoppingLocations());
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '删除失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 分页查询陪逛地点
export const fetchAccompanyShoppingLocations = createAsyncThunk(
  'accompanyShoppingLocation/fetchPage',
  async (params = { page: 1, pageSize: 10 }, { rejectWithValue }) => {
    try {
      const response = await pageLocations(params);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '获取列表失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// 获取陪逛地点详情
export const fetchAccompanyShoppingLocationDetail = createAsyncThunk(
  'accompanyShoppingLocation/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getLocationDetail(id);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '获取详情失败';
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const accompanyShoppingLocationSlice = createSlice({
  name: 'accompanyShoppingLocation',
  initialState: {
    locations: [],
    total: 0,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    currentLocation: null,
    error: null
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    }
  },
  extraReducers: (builder) => {
    // 分页查询
    builder.addCase(fetchAccompanyShoppingLocations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAccompanyShoppingLocations.fulfilled, (state, action) => {
      state.loading = false;
      console.log("action.payload", action.payload);
      state.locations = action.payload.data.records;
      state.total = action.payload.data.total;
    });
    builder.addCase(fetchAccompanyShoppingLocations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 获取详情
    builder.addCase(fetchAccompanyShoppingLocationDetail.fulfilled, (state, action) => {
      state.currentLocation = action.payload;
    });

    // 创建
    builder.addCase(createAccompanyShoppingLocation.fulfilled, (state) => {
      state.loading = false;
    });

    // 更新
    builder.addCase(updateAccompanyShoppingLocation.fulfilled, (state) => {
      state.loading = false;
    });
  }
});

export const { setPage, setPageSize } = accompanyShoppingLocationSlice.actions;
export default accompanyShoppingLocationSlice.reducer;
